//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import DropDownButton from "components/DropDownButton/DropDownButton";
import { useNavigate } from "react-router-dom";
//#endregion
//#region Images
import emptyIcon from "./img/empty.png";
//#endregion
//#region Styles
import {
    Container, 
    Content, 
    TextContent 
} from "./styles";
//#endregion

const EmptyView = ({
    isCoordinator,
    buttonProps,
    dropDownButtonProps,
    as,
    children
}) => {
    const navigate = useNavigate();
    const getModuleText = () => {
        let text = "";
        if (dropDownButtonProps)
            text = dropDownButtonProps.text;
        else
            text = buttonProps.props.text;
        return text.split(" ").filter((_, idx) => idx > 0).join(" ");
    }
    const moduleText = getModuleText();
    const buttonText = dropDownButtonProps?.text || buttonProps?.props?.text;
    return (
        <Container>
            {isCoordinator && (
                dropDownButtonProps 
                ? <DropDownButton {...dropDownButtonProps}/>
                : <CustomButton 
                    {...buttonProps.props}
                    size="medium"
                    onClick={() => navigate(buttonProps.to)}/>
            )}
            <Content>
                <img src={emptyIcon} alt={buttonText}/>
                {!isCoordinator 
                ? <TextContent>
                    <h3>Aún no tienes {moduleText}s en los que te encuentres como {as}</h3>
                    <p>En cuanto el coordinador cree {moduleText}s en los que seas {as}, los podrás visualizar en una lista</p>
                </TextContent>
                : <TextContent>
                    <h3>Aún no has creado {moduleText.toLowerCase().endsWith("a") ? "una" : "un"} {moduleText}</h3>
                    <p>
                        Empieza creando tu primer {moduleText} dando click en <strong>"{buttonText}"</strong>
                    </p>
                </TextContent>}
                {children}
            </Content>
        </Container>
    );
}

export default EmptyView;